import NotificationItem from "./NotificationItem";

const NotificationList = ({ notifications, loading, error, onItemClick, onAcceptFriend, onRejectFriend }) => {
    const handleContainerClick = (e) => e.stopPropagation();

    return (
        <div className="container" onClick={handleContainerClick}>
            {loading ? (
                <div className="loading">
                    Loading...
                </div>
            ) : error ? (
                <div className="error">{error}</div>
            ) : notifications.length > 0 ? (
                notifications.map((noti) => (
                    <NotificationItem 
                        key={noti._id} 
                        noti={noti} 
                        onClick={onItemClick} 
                        onAcceptFriend={onAcceptFriend}
                        onRejectFriend={onRejectFriend}
                    />
                ))
            ) : (
                <div className="no-notification">
                    No notification
                </div>
            )}

            <button>
                View all
            </button>
        </div>
    );
};

export default NotificationList;